<div class="flex h-screen bg-background">
  <!-- Sidebar -->
  <!-- TODO: implement responsive sidebar -->
  <div class="inset-y-0 left-0 z-50 w-64">
    <!-- fixed lg:relative lg:translate-x-0 -->
    <div class="flex flex-col h-full bg-card border-r border-border">
      <!-- <button
        class="absolute right-0 lg:hidden p-2 rounded-lg hover:bg-accent transition-colors"
        aria-label="Close sidebar"
        (click)="closeSidebar()"
      >
        <ng-icon name="featherX" class="w-4 h-4"></ng-icon>
      </button> -->

      <div class="flex items-center justify-between p-6">
        <div class="flex items-center space-x-3">
          <img
            src="/mini-logo.jpg"
            alt="Coyote Textil Logo"
            class="w-10 h-10 object-contain"
          />
          <div>
            <h1 class="text-xl font-bold text-foreground">Coyote Textil</h1>
            <p class="text-xs text-muted-foreground">Gestión de Inventario</p>
          </div>
        </div>
      </div>

      <nav class="flex-1 px-4 space-y-2">
        @if(isAdmin()) {
        <a
          routerLink="/inventario"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Inventario
        </a>
        }
        <!--  -->
        <a
          routerLink="/carrito"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Carrito de Compra
        </a>
        <!--  -->
        @if(isAdmin()) {
        <a
          routerLink="/categorias"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Categorías
        </a>
        }
        <!--  -->
        @if(isAdmin()) {
        <a
          routerLink="/proveedores"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Proveedores
        </a>
        }
        <!--  -->
        @if(isAdmin()) {
        <a
          routerLink="/productos"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Productos
        </a>
        }
        <!--  -->
        @if(isAdmin()) {
        <a
          routerLink="/almacenes"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Almacenes
        </a>
        }
        <!--  -->
        <!-- @if(isAdmin()) {
        <a
          routerLink="/ventas"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Ventas
        </a>
        } -->
        <!--  -->
        @if(isAdmin()) {
        <a
          routerLink="/usuarios"
          class="flex items-center px-4 py-3 text-sm font-medium rounded-xl transition-all duration-200 text-muted-foreground hover:text-foreground hover:bg-accent"
          routerLinkActive="bg-primary text-primary-foreground"
        >
          Usuarios
        </a>
        }
      </nav>

      <div class="p-4 border-t border-border">
        <button class="outlined normal w-full" type="button" (click)="logout()">
          Cerrar Sesión
        </button>
      </div>
    </div>
  </div>

  <!-- Main content -->
  <div class="flex-1 flex flex-col overflow-hidden">
    <main class="flex-1 overflow-auto p-6 bg-secondary/40">
      <div class="max-w-7xl mx-auto w-full h-full">
        <router-outlet />
      </div>
    </main>
  </div>
</div>
